import { IS_APP_PRODUCTION } from './app.config';

// Use Vite environment variables for API URLs
const PROD_URL = 'https://backend.v3.care.nolimit.id';
const DEV_URL = 'https://dev.backend.revamp.care.nolimit.id';

export const API_URL = IS_APP_PRODUCTION ? PROD_URL : DEV_URL;
